<template>
  <div class="dashboard">
    <v-row align="center" class="px-0 member-container">
      <v-col class="text-center px-0">
        <v-img src="../assets/2026/leader-board-header-progress.png" />
      </v-col>
      <div class="member-data" v-if="member">
        <h1>{{ member.totalClasses }}</h1>
        <p>Classes Completed</p>
        <h3>{{ charityName }}</h3>
        <h3>Pledged {{ member.pledgeClasses }}</h3>
      </div>
    </v-row>
    
    <v-row v-if="members">
      <v-col>
        <div class="round-block bluee">
          <v-row class="text-center">
            <v-col cols="6">
              <p class="mb-1"># of Participating People</p>
              <h1>{{ memberCount }}</h1>
            </v-col>
            <v-col cols="6">
              <p class="mb-1"># of People Completed</p>
              <h1>{{ memberCompletedCount }}</h1>
            </v-col>
            <v-col cols="6">
              <p class="mb-1">Total Amount Pledged</p>
              <h1>${{ memberDonationTotal }}</h1>
            </v-col>
            <v-col cols="6">
              <p class="mb-1">Total Classes for Charity</p>
              <h1>{{ memberTotalClasses }}</h1>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <label class="referenceLabel">Refer a freind</label>
        <v-text-field hide-details :value="referenceUrl" outlined disabled />
      </v-col>
      <v-col cols="12" class="text-center mb-5">
        <v-btn @click="copyToClipboard" x-large depressed color="#540811" dark>Copy My Link</v-btn>
      </v-col>
    </v-row>

    <!--<v-row v-if="memberLeaderboard">
      <v-col class="text-center">
        <heart-loader />
      </v-col>
    </v-row>

    <v-row v-if="members && !memberLeaderboardLoading">
      <v-col>
        <v-tabs color="#A9421B" class="custom-tabs" fixed-tabs v-model="tab">
          <v-tab key="75">
            75 Classes
          </v-tab>
          <v-tab key="45">
            45 Classes
          </v-tab>
          <v-tab key="15">
            15 Classes
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" background-color="transparent">
          <v-tab-item key="75">
            <v-row>
              <v-col>
                <leaderboard-table :members="seventyfiveList" />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item key="45">
            <v-row>
              <v-col>
                <leaderboard-table :members="fortyfiveList" />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item key="15">
            <v-row>
              <v-col>
                <leaderboard-table :members="fifteenList" />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-divider class="mt-10 mb-3" />-->

    <v-row v-if="isAuthenticated">
      <v-col class="text-center pb-5">
        <p class="mb-2"><small>Logged in as {{ user.full_name }} ({{ user.email }})</small></p>
        <small><a href="#" @click.prevent="logout">Is this not you?</a></small>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'
//import { DateTime } from 'luxon'

//import LeaderboardTable from '../components/LeaderboardTable.vue'
//import HeartLoader from '../components/HeartLoader.vue'

export default {
  name: 'DashboardPage',

  components: {
    //LeaderboardTable,
    //HeartLoader
  },

  data() {
    return {
      tab: 15
    }
  },

  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    user() {
      return this.$store.state.user
    },
    maxDate() {
      return this.$store.state.endDate
    },
    member() {
      return this.$store.state.member
    },
    charityName() {
      if (this.member.charityId === 4) return 'Yoga Gives Back'
      if (this.member.charityId === 5) return 'BBYCF'
      if (this.member.charityId === 6) return 'ADAPTFIT'
      return 'Unknown'
    },
    members() {
      return this.$store.state.memberLeaderboard
    },
    memberLeaderboardLoading() {
      return this.$store.state.memberLeaderboardLoading
    },
    memberCount() {
      return (this.members) ? this.members.length : 0
    },
    memberCompletedCount() {
      if (this.members) {
        const count = this.members.filter(member => {
          return (member.totalClasses >= member.pledgeClasses)
        })

        return count.length
      } else {
        return 0
      }
    },
    memberDonationTotal() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          let modifier = 0
          if (member.pledgeClasses === 24) modifier = 0
          if (member.pledgeClasses === 30) modifier = 10
          if (member.pledgeClasses === 45) modifier = 15
          if (member.pledgeClasses === 60) modifier = 20

          total = total + 10 + modifier
        })

        return total
      } else {
        return 0
      }
    },
    memberTotalClasses() {
      if (this.members) {
        let total = 0

        this.members.forEach(member => {
          total = total + member.totalClasses
        })

        return total
      } else {
        return 0
      }
    },
    fifteenList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 15)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },
    fortyfiveList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 45)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },
    seventyfiveList() {
      if (this.members) {
        const list = this.members.filter(member => member.pledgeClasses === 75)
        return orderBy(list, 'totalClasses', 'desc')
      } else {
        return []
      }
    },
    referenceUrl() {
      return `https://challenge.rayoga.com?ref=${this.user.id}`
    },
  },

  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.referenceUrl)
    },
    logout() {
      window.localStorage.removeItem('vuex')
      window.location.href = 'https://challenge.rayoga.com/login?prompt=1'
    },
  },

  async beforeMount() {
    if (!this.isAuthenticated) this.$router.push({ name: 'Home' })
    await this.$store.dispatch('getMemberLeaderboard')

    window.scrollTo(0, 0);
  }
}
</script>

<style lang="scss">
.round-block.bluee {
  background-color: #1F435D;
  color: #ffffff;
}

.custom-tabs {

  .v-tabs-slider-wrapper {
    display: none;
  }

  .v-tab {
    border-top: 2px solid #A9421B;
    border-bottom: 2px solid #A9421B;
    color: #A9421B;
    font-weight: 800;
  }

  .v-tab.v-tab--active {
    background-color: #A9421B;
    color: #ffffff;
  }

  .v-tab:nth-child(2) {
    border-left: 2px solid #A9421B;
    border-radius: 8px 0 0 8px;
  }

  .v-tab:last-child {
    border-right: 2px solid #A9421B;
    border-radius: 0 8px 8px 0;
  }
}

.member-container {
  position: relative;
}

.member-data {
  position: absolute;
  width: 100%;
  top: 130px;
  text-align: center;

  h1 {
    font-size: 100px;
    line-height: 1;
    padding: 0;
    margin: 0;
  }

  p {
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 5px;
  }

  h3 {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
    line-height: 1.2;
  }
}
</style>